<template>
  <div>
    <b-form-group
      v-if="selectedTypes.includes('email') || selectedTypes.includes('push')"
      id="input-group-subject"
      label="Email Subject"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="subject"
        required
        placeholder="Enter subject"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      id="input-group-custom-body"
      label="Custom body"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="message"
        required
        placeholder="Custom body"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      v-if="selectedTypes.includes('email')"
      id="input-group-email"
      label="Email template"
      label-for="input-3"
    >
      <b-form-select
        v-model="selectedTemplate"
        :options="templateOptions"
      ></b-form-select>
    </b-form-group>

    <b-form-group label="select a method to send notifications">
      <b-form-checkbox-group
        id="checkbox-slots"
        v-model="selectedTypes"
        :options="notifyOptions"
        name="checkbox-options-slots"
      >
      </b-form-checkbox-group>
    </b-form-group>
    <b-button
      v-if="!isLoading"
      :disabled="!validation"
      block
      variant="success"
      @click="send()"
    >
      SEND
    </b-button>
    <b-button v-else disabled block variant="success">
      <b-spinner small type="grow"></b-spinner>
      Loading...
    </b-button>
  </div>
</template>
<script>
// import firebase from "firebase";
import sendNotification from "@/services/sendNotification";
export default {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      subject: "",
      isLoading: false,
      message: "",
      selectedTypes: [],
      notifyOptions: [
        { text: "Email", value: "email" },
        { text: "Push", value: "push" },
        { text: "SMS", value: "sms" },
        { text: "Whatsapp", value: "whatsapp", disabled: true },
        { text: "Messenger", value: "messenger", disabled: true },
        { text: "Voice", value: "voice", disabled: true },
        { text: "Slack", value: "slack", disabled: true }
      ],
      templateOptions: [
        {
          text: "Standard Email",
          value: "d-32d0699b4b634609a39ce9b2340ca363"
        },
        {
          text: "Welcome Email",
          value: "d-2d92d37b067943eab2decda287dbae20"
        },
        {
          text: "Focus Created Email",
          value: "d-c35f904558be4e6eba3824e131c25a59"
        },
        {
          text: "Session Booked Email for User",
          value: "d-5594d5370b3a46b4ae8a832a26e1d30b"
        },
        {
          text: "Session Booked Email for Conductor",
          value: "d-1a026afba9194cf9a8f6de84fdfb898e"
        }
      ],
      selectedTemplate: "d-32d0699b4b634609a39ce9b2340ca363"
    };
  },
  computed: {
    validation() {
      let validation = true;
      if (this.selectedTypes.length === 0) {
        validation = false;
      } else {
        if (
          this.selectedTypes.includes("email") &&
          (this.subject === "" || this.message === "")
        ) {
          validation = false;
        } else if (this.message === "") {
          validation = false;
        }
      }

      return validation;
    }
  },
  methods: {
    send() {
      this.isLoading = true;
      sendNotification(
        this.subject,
        [this.data.userRef],
        this.selectedTypes,
        this.message,
        "JourneyBinder",
        this.selectedTemplate
      )
        .then(res => {
          this.isLoading = false;
          this.$store.dispatch("user/showNotification", {
            title: "Success",
            description: "Notifications are sent successfully.",
            variant: "success"
          });
          console.log("sent", res);
        })
        .catch(error => {
          this.isLoading = false;
          this.$store.dispatch("user/showNotification", {
            title: error,
            description: error.message,
            variant: "danger"
          });
        });
    }
  }
};
</script>
